import React from 'react'
import { makeStyles, Icon } from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined'
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined'
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import { ShareIcon } from 'app/components/icons'

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.secondary.main,
  },
}))

const PreviewAction = ({ notification }) => {
  const classes = useStyles()
  return (
    <div className="flex justify-between w-full">
      <div className="flex w-64 h-48 justify-center items-center">
        <ThumbUpAltOutlinedIcon fontSize="small" className="text-grey-300" />
      </div>
      {notification.allowConversation && (
        <div className="flex w-64 h-48 justify-center items-center">
          <ChatBubbleOutlineOutlinedIcon
            fontSize="small"
            className="text-grey-300"
          />
        </div>
      )}
      <div className="flex w-64 h-48 justify-center items-center">
        <BookmarkBorderOutlinedIcon
          fontSize="small"
          className="text-grey-300"
        />
      </div>
      <div className="flex w-64 h-48 justify-center items-center">
        <DateRangeOutlinedIcon fontSize="small" className="text-grey-300" />
      </div>
      <div className="flex w-64 h-48 justify-center items-center">
        <ShareIcon />
      </div>
    </div>
  )
}

export default PreviewAction
